import React from "react"
import "./Layout.css"
import AldooBoot from "aldoo-ra/Boot"
import Site from "../components/Site"
import ResetStorage from "../components/ResetStorage"
export function Layout({ children }) {
  return (
    <React.StrictMode>
      <AldooBoot />
      <ResetStorage />
      <Site>{children}</Site>
    </React.StrictMode>
  )
}